import React from "react";

/* --- SkeletonText --- */

export interface SkeletonTextProps {
  lines?: number;
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({ lines = 3 }) => {
  const widths = ["w-full", "w-5/6", "w-4/6", "w-3/4", "w-2/3"];
  return (
    <div className="animate-pulse space-y-2.5">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={["h-3 rounded-md bg-ds-surface", widths[i % widths.length]].join(" ")}
        />
      ))}
    </div>
  );
};

/* --- SkeletonCard --- */

export const SkeletonCard: React.FC = () => (
  <div className="animate-pulse rounded-2xl border border-ds-border bg-white p-5 space-y-3">
    <div className="h-32 rounded-xl bg-ds-surface" />
    <div className="h-4 w-3/4 rounded-md bg-ds-surface" />
    <div className="h-3 w-1/2 rounded-md bg-ds-surface" />
  </div>
);

/* --- SkeletonTable --- */

export interface SkeletonTableProps {
  rows?: number;
  columns?: number;
}

export const SkeletonTable: React.FC<SkeletonTableProps> = ({
  rows = 5,
  columns = 4,
}) => (
  <div className="animate-pulse space-y-3">
    {/* header */}
    <div className="flex gap-4">
      {Array.from({ length: columns }).map((_, c) => (
        <div key={c} className="h-4 flex-1 rounded-md bg-ds-surface" />
      ))}
    </div>
    {/* rows */}
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex gap-4">
        {Array.from({ length: columns }).map((_, c) => (
          <div key={c} className="h-3 flex-1 rounded-md bg-ds-surface" />
        ))}
      </div>
    ))}
  </div>
);

/* --- SkeletonAvatar --- */

export interface SkeletonAvatarProps {
  size?: number;
}

export const SkeletonAvatar: React.FC<SkeletonAvatarProps> = ({ size = 40 }) => (
  <div
    className="animate-pulse rounded-full bg-ds-surface"
    style={{ width: size, height: size }}
  />
);
